export const featureFlags = {
  universeKodyCardMfe: 'Universe_KodyCard_MFE',
  sendMoney: 'PP-460_send_money',
  recurringWithdrawals: 'KU-218_recurring-withdrawals',
  settlements: 'RK-12_settlements',
  domesticTransfers: 'pp-812-domestic-transfers',
  kodyAppCustomEventMonitoring: 'kill-switch-disable-kody-app-custom-event-monitoring',
  kuWebCustomEventMonitoring: 'kill-switch-disable-ku-web-custom-event-monitoring',
  wombatWebCustomEventMonitoring: 'kill-switch-disable-wombat-web-custom-event-monitoring',
  integratedPaymentsAppCustomEventMonitoring: 'kill-switch-disable-integrated-payments-app-custom-event-monitoring',
  payByBankAppCustomEventMonitoring: 'kill-switch-disable-pay-by-bank-app-custom-event-monitoring',
  kodyAppHomeSalesChart: 'KA-69-Home-Sales-Chart',
  attachmentUpload: 'PP-749-Attachments',
  pinRevealV2: 'KU-324-pin_reveal_v2',
  enableLanguageChange: 'PP-926_pbl_locale',
  nativeSettlements: 'ka-121-native-settlements-feature',
  deposits: 'KU-335_deposits',
  payByLinkDeposits: 'GE-63-PBL-Deposits',
  payByLinkSaveCustomerInfo: 'GE-64-PBL-Save-Customer-Information',
  payByLinkSaveNotificationSettings: 'GE-64-PBL-Save-Notification-Settings',
  refundTransactions: 'KU-354-Refund-Transactions',
  insights: 'KU-390-customer-insights',
  insightsQuartilePointsChart: 'sos-59-quartile-points-chart',
  insightsSpendingByCountryChart: 'sos-139-spending-by-country-chart',
  insightsRevenueStoreVisitsChart: 'SOS-176-store-visits-chart',
  loyalty: 'SOS-33-Loyalty',
  loyaltyReservedDates: 'SOS-344-Loyalty',
  loyaltyRedeemMultipleRewards: 'SOS-366-Loyalty-redeem-multi',
  membership: 'SOS-174-membership',
  campaignStats: 'sos-191-campaign-stats',
  campaignRedemptions: 'sos-168-campaign-redemptions',
  displayTransactionFees: 'PAY-612-display_transaction_fees',
  loyaltyDiscountInSalesTab: 'sos-466-loyalty-discount-in-sales-tab',
  payByBankPayments: 'PAY-34-pbb_payments',
  virtualTerminal: 'sos-875-virtual-terminal',
  settlementDownloadPdf: 'KU-settlement-download-pdf',
  transactionsSalesCharts: 'KU-transactions-sales-charts',
  transactionsSalesChartsV2: 'KU-transactions-sales-charts-v2',
  settlementDownloadPdfV2: 'KU-settlement-download-pdf-v2',
  mccRevert: 'KU-mcc-revert',
  customerFeeDownload: 'ku-customer-fee-download',
  kycReason: 'ku-kyc-reason',
  apiKey: 'INS-1198-ApiKey',
  aiAgent: 'KU-AI-ChatRobot',
  aiAgentFullPage: 'KU-AI-AGENT-FULL-PAGE',
  frenchLanguage: 'INS-1229-Support-FR',
  statementTab: 'ku-statement-tab',
  cashAdvance: 'ku-cash-advance',
  cashAdvanceViewHistory: 'ku-ca-view-history-button',
  mfaCustomAuthLogin: 'mfa-custom-auth-login',
  preAuthListCardDetail: 'ku-pre-auth-list-card-detail',
  popupGuide: 'ku-popup-guide',
  // Store-scoped: a JSON array of storeIds ("*" for every store), controlling
  // whether a merchant's shopper sees our payment completion page before being
  // forwarded to their return_url. It has to hold the list in the flag value
  // because this app identifies to LaunchDarkly anonymously, so LaunchDarkly's
  // own per-store targeting has no storeId to match on — which is why the
  // boolean v1 of this flag could never be rolled out per store.
  integratedPaymentsCompletionPage: 'ip-payment-completion-page-v2',
};
